import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NzModalRef } from "ng-zorro-antd/modal";

import { environment as env } from "../../../../environments/environment";

@Component({
  selector: "app-user-login",
  templateUrl: "./app-user-login.component.html",
  styleUrls: ["./app-user-login.component.scss"],
})
export class AppUserLoginComponent implements OnInit {
  private readonly appUserConnections = env.appUserConnections;

  usernamePassword: String = "";
  google: String = "";
  line: String = "";
  apple: String = "";

  constructor(
    private translate: TranslateService,
    private modalRef: NzModalRef
  ) {
    this.usernamePassword = this.translate.instant(
      "appUserLogin.usernamePassword"
    );
    this.google = this.translate.instant("appUserLogin.google");
    this.line = this.translate.instant("appUserLogin.line");
    this.apple = this.translate.instant("appUserLogin.apple");

  }

  ngOnInit(): void {}

  selectOption(option: string) {
    let connection = this.appUserConnections[option];

    if (!connection) {
      connection = null;
    }

    this.modalRef.destroy(connection);
  }
}
